
import ToolBarBottom from '../../components/ToolBarBottom'
import Scroller from 'vux/src/components/scroller/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Search from 'vux/src/components/search/index.vue'


export default {
name: 'myOrderList',
components: {
ToolBarBottom,
Scroller,
Panel,
Search
},
data () {
return {
platcode: '',
pageNo: 1,
pageSize: 10,
orderList: [],
searchKey: '',
pullupConfig: {
content: '',
downContent: '松开进行加载',
upContent: '上拉加载更多',
loadingContent: '加载中...'
}
}
},
created: function () {
this.platcode = this.$UserUtils.getPlatCode()
},
mounted: function () {
this.loadOrderListFirst()
},
methods: {
loadOrderList: function () {
var that = this
setTimeout(() => {

var url = '/wxapi/order/getOrderListByPage?platcode=' + that.platcode + '&pageNo=' + that.pageNo + '&pageSize=' + that.pageSize + '&searchKey=' + that.searchKey
this.$axios.post(url, {}).then(function (res) {
if (res.meta.success) {
for (var j = 0, len = res.data.length; j < len; j++) {
that.orderList.push(res.data[j])
}
that.pageNo ++
setTimeout(() => {
that.$refs.orderListScroller.donePullup()
}, 100)
} else {
if (res.redirect) {
location.href = res.data
} else {
that.$Msgbox.alert(res.meta.message, '异常提示')
}
}
})
}, 100)
},
loadOrderListFirst: function () {
var that = this
var url = '/wxapi/order/getOrderListByPage?platcode=' + that.platcode + '&pageNo=' + that.pageNo + '&pageSize=' + that.pageSize + '&searchKey='
this.$axios.post(url, {}).then(function (res) {
if (res.meta.success) {
for (var j = 0, len = res.data.length; j < len; j++) {
that.orderList.push(res.data[j])
}
that.pageNo ++
} else {
if (res.redirect) {
location.href = res.data
} else {
that.$Msgbox.alert(res.meta.message, '异常提示')
}
}
})
},
fun_to_orderdetail: function (orderid) {
console.log(orderid)
window.location.href = '/wx/order/orderdetail?orderid=' + orderid + '&platcode=' + this.platcode
},

onSubmit: function () {
this.$refs.search.setBlur()
this.pageNo = 1
this.orderList.length = 0
this.loadOrderList()
},
onCancel: function () {
console.log('on cancel')
}
}
}



// WEBPACK FOOTER //
// ./src/pages/order/MyOrderList.vue